import {
  getSvgFromMemory,
  setSvgToMemory,
  getSvgFromLocalStorage,
  setSvgToLocalStorage,
  SVG_CACHE_TTL_MS,
} from "./svgCache";
import { sanitizeSvg } from "./sanitizeSVG";

export const loadSvg = async (
  url: string,
  ttlMs: number = SVG_CACHE_TTL_MS
): Promise<SVGSVGElement | null> => {
  if (typeof window === "undefined") return null;

  // 1. memory cache
  const mem = getSvgFromMemory(url);
  if (mem) {
    // clone node for avoiding mutate root instance
    return mem.cloneNode(true) as SVGSVGElement;
  }

  // 2. localStorage cache
  const cachedText = getSvgFromLocalStorage(url);
  if (cachedText) {
    const svg = sanitizeSvg(cachedText);
    if (svg) {
      setSvgToMemory(url, svg);
      return svg.cloneNode(true) as SVGSVGElement;
    }
  }

  // 3. fetch from network
  try {
    const res = await fetch(url,
      {
        method: 'GET',    
        cache: 'no-cache',
      }
    );
    if (!res.ok) {
      console.error("[SVG] fetch error:", url, res.status);
      return null;
    }
    const text = await res.text();
    const svg = sanitizeSvg(text);
    if (!svg) return null;

    setSvgToMemory(url, svg);
    setSvgToLocalStorage(url, text, ttlMs);

    return svg.cloneNode(true) as SVGSVGElement;
  } catch (e) {
    console.error("[SVG] fetch exception:", url, e);
    return null;
  }
};
